import { COLOR_PRIMARIO } from 'cfgCommon/colors'
import { checkValidEmail, validPhoneWhatsApp } from 'Utilities';

export const LINE_BREAK = '\n';

export const OPTION = {
    WHATSAPP:'whatsapp',
    EMAIL:'email'    
}

export const ERROR_HELPER_TEXT = {
    whatsapp: 'Formato inválido. Ingresá nuevamente el número.',
    email: 'Formato inválido. Ingresá nuevamente el Email.',
    emptyField: 'El campo no puede estar vacío.'
  }

export const WHATSAPP_HELPER_TEXT = 'Incluí el código de país y el teléfono sin el 0 y sin el 15.'
  
export const MAX_PHONE_LENGTH = 13
  
export const COLOR_PRIMARY = { color: COLOR_PRIMARIO}

export const STEPS = [
  {
      key: 0,
      label: 'Tipo de presupuesto',
      type: 'TIPO',
      order: 0,
      canGoBack: false
  },
  {
      key: 1,
      label: 'Medios de envío',
      type: 'MEDIO',
      order: 1,
      canGoBack: true,
      isLastStep: true
  }
]

export const STEP_INDEX = {one: 0, two: 1}

export const BUDGET_TYPES = {
  pdf: 'pdf',
  interactive: 'interactive'
}

export const verifyField = {
    whatsapp: validPhoneWhatsApp,
    email: checkValidEmail,
}

export const STOCK_STATES = {
  ACTIVO: "Activo",
  SUJETO_A_DEFINICION: "Sujeto a definición",
  RESERVADO: "Reservado",
  RESERVADO_SV: "Reservado SV",
  FACTURADO: "Facturado",
  NO_A_LA_VENTA: "No a la venta",
  PRONTO_EN_STOCK: "Pronto en stock",
}